<template>
  <div class="page-container">
  
    
    <div class="main-content">
      <main class="content-area">
        
        <div v-if="standardContent" class="api-content">
          <div class="content-card">
            <!-- <h3 class="content-title">{{ standardTitle || '军队院校招收学员体格检查标准' }}</h3> -->
            <h4 class="content-subtitle">《军队选拔军官和文职人员体检标准》</h4>
            <div class="content-body" v-html="standardContent"></div>
          </div>
        </div>
        
        <div v-else class="loading-state">
          <div class="loading-spinner"></div>
          <p>加载中...</p>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { getMedicalStandard } from "@/api/processApi";
import { baseURL } from "@/api/axiosConfig";

export default {
  name: "PhysicalStandard",
  data() {
    return {
      standardTitle: '',
      standardContent: ''
    };
  },
  mounted() {
    this.fetchMedicalStandard();
  },
  methods: {
    addImageBaseUrl(content) {
      if (!content) return "";
      return content.replace(/<img[^>]+src="\/(dev-api\/)?profile\/upload\/[^"]+"/g, (match) => {
        return match.replace(/src="\/(dev-api\/)?profile\/upload\//, `src="${baseURL}/profile/upload/`);
      });
    },
    
    fetchMedicalStandard() {
      getMedicalStandard().then(response => {
        if (response.data.code === 200) {
          const data = response.data.data;
          this.standardTitle = data.title || '军队院校招收学员体格检查标准';
          this.standardContent = this.addImageBaseUrl(data.pdfurl) || '';
        }
      }).catch(error => {
        console.error('获取体检标准失败:', error);
      });
    }
  }
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  margin-top: 60px;
  padding: 0 10px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f4f8 100%);
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
}

.page-title {
  font-size: 32px;
  color: #1976d2;
  margin: 0 0 8px 0;
  font-weight: bold;
}

.page-subtitle {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.main-content {
  max-width: 1500px;
  margin: 0 auto;
}

.content-area {
  width: 100%;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 20px;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f0f0f0;
  border-top-color: #1976d2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-state p {
  font-size: 16px;
  color: #999;
  margin: 0;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 26px;
  }
  
  .content-title {
    font-size: 18px;
  }
}

.api-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.content-card .content-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 16px 0;
  font-weight: 600;
  text-align: center;
}

.content-card .content-subtitle {
  font-size: 18px;
  color: #c62828;
  margin: -10px 0 20px 0;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
  border-bottom: 2px solid #ffcdd2;
}

.content-body {
  font-size: 15px;
  color: #333;
  line-height: 1.8;
}

.content-body h1,
.content-body h2,
.content-body h3,
.content-body h4 {
  font-size: 16px;
  color: #1976d2;
  margin: 20px 0 10px 0;
  font-weight: 600;
  text-align: center;
}

.content-body p {
  margin: 0 0 12px 0;
}

.content-body ul, .content-body ol {
  margin: 0 0 12px 20px;
  padding: 0;
}

.content-body li {
  margin-bottom: 8px;
}
</style>